<template>
  <v-expansion-panel
    popout
    v-model="panel"
    :value="0"
  >
    <v-expansion-panel-content
      v-for="(item,i) in years"
      :key="i"
      class="mt-3"
      :class="{'elevation-2': i !== panel, 'elevation-8 transparent': i === panel}"
    >
      <div
        slot="header"
        class="subheading"
      >{{item.date.year}}
      </div>

      <v-card class="transparent">
        <v-card-text>
          <v-progress-linear
            indeterminate
            v-show="item.isFetching"
          />
          <v-list
            class="transparent"
            v-show="!item.isFetching"
            subheader
          >
            <template v-for="(subItem) in item.year">

              <v-list-tile
                :key="subItem.title"
              >
                <v-list-tile-avatar>
                  <v-icon
                    :color="'primary ' + subItem.color"
                    :size="subItem.size"
                  >fa-sun</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="yield__month">{{ subItem.label }}</v-list-tile-title>
                </v-list-tile-content>
                <strong class="month-yield">{{round(subItem.yield / 1000)}}
                  <small class="month-yield__unit">{{unit}}</small>
                </strong>
              </v-list-tile>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { round, roundCurrency } from '@/helpers/yields';

export default {
  props: ['isFetching', 'years', 'view'],

  data() {
    return {
      panel: 0,
    };
  },

  watch: {
  },

  computed: {
    round() { return this.view === 'yield' ? round : roundCurrency; },

    unit() { return this.view === 'yield' ? 'kWh' : 'EUR'; },
  },
};
</script>
